import React, { useState } from 'react';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { peopleSelectMenuProps } from '../dashboardcomponents/People/peopleSelectStyles';

const menuItemSx = {
  fontFamily: 'Inter',
  fontSize: 14,
};

function LeadSelectInput(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedOption, setSelectedOption] = useState(props.value || 'Social Media');
  const {
    name = 'name',
    id = 'id',
    onChange = () => {},
    value,
    popupIcon,
  } = props;

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (option) => {
    setSelectedOption(option);
    handleClose();
    if (props.onChange) {
      props.onChange(option);
    }
  };

  const options = [
    'Social Media',
    'Google Ads',
    'Direct Referral',
    'Website',
  ];

  const ITEM_HEIGHT = 48;

  return (
    <div>
      <Button
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        name={name}
        value={value}
        onChange={onChange}
        aria-haspopup="true"
        onClick={handleClick}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          color: '#405261',
          border: '1px solid #D5DCE1',
          fontSize: '12px',
          fontWeight: '500',
          borderRadius: '8px',
          padding: '10px 13px',
          width: '100%',
          textTransform: 'capitalize',
          marginTop: '8px',
        }}
      >
        {selectedOption}
        {popupIcon}
      </Button>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            ...peopleSelectMenuProps.PaperProps.sx,
            maxHeight: ITEM_HEIGHT * 4.5,
            width: anchorEl ? Math.max(anchorEl.clientWidth, 200) : '37ch',
            textTransform: 'capitalize',
          },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            selected={option === selectedOption}
            onClick={() => handleMenuItemClick(option)}
            className="Select-number"
            sx={menuItemSx}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default LeadSelectInput;
